import React from "react"
import { connect } from "react-redux"
import { compose, defaultProps } from "recompact"
import eventModel from "src/models/event"
import entityList from "src/hocs/entityList"
import EntityListEditor from "src/components/EntityListEditor"
import { DEFAULT_DATE_FORMAT } from "src/containers/Calendar/constants"
import queryString from "query-string"
import moment from "moment"
import {
  DEFAULT_COLOR,
  makeTransparent,
} from "src/containers/Calendar/helpers/eventToItem"
import tooltip from "@infotech/uikit-tooltip"
import {
  EVENT_CREATE,
  EVENT_DELETE,
  EVENT_UPDATE,
  EVENTS_CHANGE_STATUS,
} from "src/constants/knownPermissions"
import { EVENTS_URL } from "src/constants/routeNames"
import { hasPermission } from "src/engine/modules/currentUser"
import SmallLockIcon from "src/icons/smallLock.svg"
import Item, { FORM_NAME } from "./Item"
import FilterForm from "./Filter"
import styles from "./styles.css"

const TooltipSpan = tooltip.span()

const closeModal = ({ history, queryParams }) => () => {
  history.push(`${EVENTS_URL}?${queryString.stringify(queryParams)}`)
}

export const columns = () => [
  {
    accessor: `name`,
    Header: `Наименование события`,
    maxWidth: 285,
    sortable: true,
  },
  {
    Header: `Тип события`,
    accessor: `eventTypeName`,
    maxWidth: 300,
    sortable: true,
    Cell: ({ original: { eventTypeColor: color, eventTypeName: name } }) => (
      <div>
        <span
          className={styles.circle}
          style={{
            backgroundColor: `${
              color === `#fff`
                ? DEFAULT_COLOR
                : typeof color === `string` && makeTransparent(color, 0.4)
            }`,
          }}
        />
        <span className={styles.name}>{name}</span>
      </div>
    ),
  },
  {
    accessor: `startDateTime`,
    Header: `Начало`,
    sortable: true,
    maxWidth: 140,
    Cell: ({ original: { startDateTime: seconds } }) => (
      <div>{moment(seconds).format(DEFAULT_DATE_FORMAT)}</div>
    ),
  },
  {
    accessor: `endDateTime`,
    Header: `Окончание`,
    sortable: true,
    maxWidth: 140,
    Cell: ({ original: { endDateTime: seconds } }) => (
      <div>{moment(seconds).format(DEFAULT_DATE_FORMAT)}</div>
    ),
  },
  {
    accessor: `planName`,
    Header: `План`,
    sortable: true,
  },
  {
    accessor: `statusName`,
    Header: `Статус`,
    sortable: true,
    Cell: ({ original: { status } }) => status && <div>{status.name}</div>,
  },

  {
    accessor: `locked`,
    Header: () => (
      <div>
        <SmallLockIcon size="small" color="#bfbfbf" />
        &nbsp;
      </div>
    ),
    sortable: true,
    width: 80,
    Cell: ({ original: { locked } }) => (
      <div>
        {locked && (
          <TooltipSpan
            tooltip="Заблокировано"
            tooltipConfig={{
              placement: `top`,
            }}
          >
            <span>
              <SmallLockIcon size="small" color="#bfbfbf" />
            </span>
          </TooltipSpan>
        )}
      </div>
    ),
  },
]

const enhancer = compose(
  entityList({
    model: eventModel,
    ITEM_FORM_NAME: FORM_NAME,
    baseUri: EVENTS_URL,
    columns,
  }),
  defaultProps({
    EntityEditor: compose(
      defaultProps({
        onCreate: props => {
          const {
            event: { createdId },
            history,
          } = props
          history.push(`${EVENTS_URL}/${createdId}`)
        },
        onUpdate: closeModal,
      }),
      connect(state => ({
        canEdit: () => hasPermission(EVENT_UPDATE)(state),
      })),
    )(Item),
    FilterEditor: FilterForm,
    fullWidth: true,
    fullHeight: true,
  }),
  connect(state => ({
    disableCreate: !hasPermission(EVENT_CREATE)(state),
    canEdit: () => hasPermission(EVENT_UPDATE)(state),
    canDelete: () => hasPermission(EVENT_DELETE)(state),
    canChangeStatus: () => hasPermission(EVENTS_CHANGE_STATUS)(state),
  })),
)

export default enhancer(EntityListEditor)
